var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',[_c('div',{staticClass:"py-xxl has-text-white has-text-centered"},[_c('h1',{staticClass:"is-size-4"},[_vm._v("Reporting")])])]),_c('div',{staticStyle:{"height":"1px"}})]),_c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"has-background-white pa-xxl rounded-xl"},[_vm._v(" Coming Soon. ")])])])])
}]

export { render, staticRenderFns }